import React from 'react'
import { Icon } from '../Icon'
import { Alert as AlertCore } from 'react-bootstrap'

export type AlertType = 'danger' | 'info' | 'success' | 'warning' | string

export type AlertProps = {
  children?: React.ReactNode
  type?: AlertType
  style?: any
  icon?: any
  text?: any
  className?: string
}
/**
 *  The common alert function
 */
export const Alert = ({ children, type = 'danger', style, icon, text, className }: AlertProps) => {
  let renderIcon = null
  if (icon) {
    if (typeof icon === 'string') {
      renderIcon = <Icon name={icon} className="me-2" />
    } else renderIcon = icon
  }
  let renderText = null
  if (text) {
    renderText = text
  }
  return (
    <AlertCore variant={type} style={style} className={className}>
      {children}
      {renderIcon}
      {renderText}
    </AlertCore>
  )
}
